import authInstance from "../utilities/axios/authInstance";

export const allSettings = () => authInstance.get('settings/get');

export const addSettings = (formData) => authInstance.post('settings/update', formData, {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
});